

import Crk from '@/mixins/crk/crk';
import { DigitalSignCommonData, DigitalSignResult } from '@/mixins/crk/interface';
import { IProfileEntity } from '@/models/modules/profile/interface';
import { PROFILE_MODULE_NAME } from '@/store/modules/profile';
import { Component, Emit, Mixins, VModel, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { DigitalSign } from '../types/digital-sign';
import DigitalSignPasswordDialog from './DigitalSignPasswordDialog.vue';

@Component({
	components: {
		DigitalSignPasswordDialog
	}
})
export default class DigitalSignCurrentCompanyDialog extends Mixins(
	Crk
) {

	@Getter('profile', { namespace: PROFILE_MODULE_NAME })
	readonly profile!: IProfileEntity

	@VModel({ type: Boolean })
	passwordDialog!: boolean

	selectedDigitalSign: DigitalSign = null

	signResult: DigitalSignResult | null = null

	async onSubmitPassword(digitalSign?: DigitalSign) {
		this.selectedDigitalSign = {
			...(digitalSign || {}),
			...(this.selectedDigitalSign || {})
		};

		this.signResult = await this.signData();

		this.signResult?.error || this.emitSign();
	}

	async signData(): Promise<DigitalSignResult> {
		return this.signObject(
			this.signatureData,
			this.selectedDigitalSign,
			this.password
		);
	}

	selectCurrentCompanyDigitalSign() {
		this.selectedDigitalSign = {
			flCrmId: this.profile?.flCrmId,
			ulCrmId: this.profile?.ulCrmId,
			mfoUl: this.profile?.mfoUl,
		};
	}

	@Watch('passwordDialog')
	onPasswordDialogChanged() {
		this.passwordDialog
			&& this.selectCurrentCompanyDigitalSign();
	}

	@Emit('sign')
	emitSign(): DigitalSignCommonData {
		return {
			object: this.signResult?.result?.base64ToString || '',
			sign: this.signResult?.result?.sign || '',
		};
	}

}

